import {Component, inject} from '@angular/core';
import {LucideAngularModule} from 'lucide-angular';
import {FieldBaseComponent} from '@shared/form/field-base.component';
import {map, Observable} from 'rxjs';
import {ReactiveFormsModule} from '@angular/forms';
import {Choice} from '@shared/form/choice/choice';
import {ActivityTagDTO} from '@domain/activity-tag/activity-tag.dto';
import {ActivityTagApi} from '@domain/activity-tag/activity-tag.api';
import {AutocompleteFieldComponent} from '@shared/form/choice/autocomplete-field/autocomplete-field.component';

@Component({
  selector: 'app-activity-tag-field',
  imports: [
    LucideAngularModule,
    ReactiveFormsModule,
    AutocompleteFieldComponent
  ],
  templateUrl: './activity-tag-field.component.html',
  styleUrl: './activity-tag-field.component.scss'
})
export class ActivityTagFieldComponent extends FieldBaseComponent<ActivityTagDTO | null> {

  private readonly tagApi = inject(ActivityTagApi);

  public readonly choiceProvider: (term: string) => Observable<Choice<Partial<ActivityTagDTO>>[]> = (term) => {
    return this.tagApi.search(term).pipe(
      map(tags => tags.map(tag => ({
        value: tag ?? null,
        text: this.getTagLabel(tag) ?? ''
      })))
    );
  }

  private getTagLabel(tag: ActivityTagDTO | null): string | null {
    return tag?.code ?? null;
  }

  public readonly valueLabel: (value: ActivityTagDTO) => string | null = (tag) => {
    return this.getTagLabel(tag);
  }
}
